import { Box, Checkbox, Flex, Text } from "@radix-ui/themes";
import { Control, Controller, FieldErrors } from "react-hook-form";
import styles from "./CheckboxComponent.module.scss";
import { fieldAria, fieldIds, resolveFieldError } from "../FieldShell";

interface CheckboxProps {
  name: string;
  label: string;
  control: Control<any>;
  errors: FieldErrors<any>;
  style?: React.CSSProperties;
  defaultChecked?: boolean;
  disabled?: boolean;
  required?: boolean;
  hint?: string;
  /** Descrição para leitores de ecrã quando a caixa não tem etiqueta visível. */
  ariaLabel?: string;
  onChange?: (checked: boolean) => void;
}

const CheckboxComponent = ({
  name,
  label,
  control,
  errors,
  style,
  defaultChecked = false,
  disabled = false,
  required = false,
  hint,
  ariaLabel,
  onChange,
}: CheckboxProps) => {
  const error = resolveFieldError(errors, name);
  const { fieldId, errorId, hintId } = fieldIds(name);
  const hasVisibleLabel = !!label;

  return (
    <Box style={style}>
      <Controller
        name={name}
        control={control}
        defaultValue={defaultChecked}
        render={({ field }) => (
          <Flex align="center" gap="2">
            <Checkbox
              size="1"
              id={fieldId}
              checked={!!field.value}
              disabled={disabled}
              color={error ? "red" : undefined}
              aria-label={hasVisibleLabel ? undefined : ariaLabel ?? name}
              {...fieldAria(name, error, hint)}
              onCheckedChange={(checked) => {
                field.onChange(checked);
                onChange?.(checked as boolean);
              }}
            />
            {hasVisibleLabel && (
              <Text as="label" size="2" htmlFor={fieldId} className={styles.label}>
                {label}{" "}
                {required && (
                  <Text color="red" aria-hidden="true">
                    *
                  </Text>
                )}
              </Text>
            )}
          </Flex>
        )}
      />

      {hint && !error && (
        <Text as="p" size="1" color="gray" id={hintId}>
          {hint}
        </Text>
      )}

      {error && (
        <Text as="p" size="1" color="red" id={errorId} role="alert">
          {error}
        </Text>
      )}
    </Box>
  );
};

export default CheckboxComponent;
